const getDistinctId = () => localStorage.getItem('distinctId')

const setDistinctId = distinctId => localStorage.setItem('distinctId', distinctId)

export { getDistinctId, setDistinctId }
